import gql from 'graphql-tag';

const CONFIRM_MY_DAY_STEP = gql`
	mutation confirmMyDayStepMutation($id: ID!, $stepKey: String!, $adminTraining: Boolean, $items: [String!]) {
		confirmMyDayStep(id: $id, stepKey: $stepKey, adminTraining: $adminTraining, items: $items) {
			id
			myDayConfirmations {
				key
				at
				items
			}
		}
	}
`;

export default CONFIRM_MY_DAY_STEP;
